export const otherModule = {
  loadingPay: "支払結果へ",
  goDetail: "注文詳細へ"
};
